import {ajax,getRequestUrl,formatData} from "../request";

export default {
  agentListByPage(data, method) {
    return ajax('post', getRequestUrl('/useragent/agentData/dataList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  extendListByPage(data, method) {
    return ajax('post', getRequestUrl('/api/AgentManagement/extendListByPage'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  extendTransferListByPage(data, method) {
    return ajax('post', getRequestUrl('/api/AgentManagement/extendTransferListByPage'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  setAgency(data, method) {
    return ajax('post', getRequestUrl('/api/AgentManagement/setAgency'), data, {
      method,
    });
  },

  deleteAgency(data, method) {
    return ajax('post', getRequestUrl('/api/AgentManagement/deleteAgency'), data, {
      method,
    });
  },

  monthStatistic(data, method) {
    return ajax('post', getRequestUrl('/api/AgentManagement/monthStatistic'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  rechargeAgencyList(data, method) {
    return ajax('post', getRequestUrl('/useragent/agentRecharge/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  transferRecord(data, method) {
    return ajax('post', getRequestUrl('/useragent/agentData/saleList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  rechargeAgency(data, method) {
    return ajax('post', getRequestUrl('/useragent/agentRecharge/agentRecharge'), data, {
      method,
    });
  },

  rechargeAgencyComfirm(data, method) {
    return ajax('post', getRequestUrl('/useragent/agentRecharge/confirmOrder'), data, {
      method,
    });
  },

  cancelOrder(data, method) {
    return ajax('post', getRequestUrl('/api/AgentManagement/cancelOrder'), data, {
      method,
    });
  },

  agencyList(data, method) {
    return ajax('post', getRequestUrl('/useragent/agentInfo/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  agencyAdd(data, method) {
    return ajax('post', getRequestUrl('/useragent/agentInfo/save'), data, {
      method,
    });
  },

  editBindUser(data, method) {
    return ajax('post', getRequestUrl('/api/AgentManagement/editBindUser'), data, {
      method,
    });
  },

  bindUserList(data, method) {
    return ajax('post', getRequestUrl('/api/AgentManagement/bindUserList'), data, {
      method,
    });
  },

  transferPremiumList(data, method) {
    return ajax('post', getRequestUrl('/api/AgentManagement/transferPremiumList'), data, {
      method,
    });
  },

  rechargeAgentInfo(data, method) {
    return ajax('post', getRequestUrl('/user/agent/recharge'), data, {
      method,
    });
  },

  dividedInto(data, method) {
    return ajax('post', getRequestUrl('/api/AgentManagement/dividedInto'), data, {
      method,
    });
  },

  agencyDisable(data, method) {
    return ajax('post', getRequestUrl('/useragent/agentInfo/setOn'), data, {
      method,
    });
  },

  agencyUserBind(data, method) {
    return ajax('post', getRequestUrl('/api/AgentManagement/agencyUserBind'), data, {
      method,
    });
  },

  agencyUserBindOperate(data, method) {
    return ajax('post', getRequestUrl('/api/AgentManagement/agencyUserBindOperate'), data, {
      method,
    });
  },

  getAgentFirst(data, method) {
    return ajax('post', getRequestUrl('/api/AgentManagement/getAgentFirst'), data, {
      method,
    });
  },

  queryAgentInfoList(data, method) {
    return ajax('post', getRequestUrl('/useragent/agentRecharge/queryAgentInfoList'), data, {
      method,
    });
  },

  setAgencyCountry(data, method) {
    return ajax('post', getRequestUrl('/useragent/agentInfo/setSaleCountrys'), data, {
      method,
    });
  },

  settingAdminList(data, method) {
    return ajax('post', getRequestUrl('/setting/adminList'), data, {
      method,
    });
  },
}



// WEBPACK FOOTER //
// ./src/js/https/agent.js